export default "__VITE_ASSET__CiyVhttZ__"